import {filtersSelector} from "@app-redux/selectors";
import {useAppSelector} from "@app-redux/store";
import {FiltersChipPanel} from "@components/FiltersChipPanel";
import {ProfileTableSkeleton} from "@components/Skeletons";
import {ProfileTable} from "@components/ProfileTable";
import {Search} from "@components/Search";
import {ROUTER_PATHS} from "@/constants";
import AddIcon from "@mui/icons-material/Add";
import FileDownload from "@mui/icons-material/FileDownload";
import {Button} from "@mui/material";
import {useState} from "react";
import {Link} from "react-router-dom";
import styles from "./styles.module.css";
import {getCategoryFilters} from "@/utils";
import {useExportProfileList, useCategories, useUserData, useProfileListWithFilters} from "@/hooks/queries";
import {useNotification} from "@/hooks/useNotification";

export const ResultsPanel = () => {
  const filters = useAppSelector(filtersSelector);
  const {map, data} = useCategories();
  const { data: userData } = useUserData();
  const isAdmin = userData?.isAdmin;
  const exportMutation = useExportProfileList();
  const { data: profileListData, isLoading } = useProfileListWithFilters();
  const { notifySuccess, notifyError } = useNotification();

  const count = profileListData?.pages[0]?.count ?? 0;
  const [scrollHeight, setScrollHeight] = useState(0);
  const scrollHeightValue = `calc(100% - 40px - 16px - ${scrollHeight}px)`;
  return (
    <div className={styles.container}>
      <div className={styles.topPanel}>
        <h1>All Profiles</h1>
        <Search className={styles.search}/>
        <span className={styles.resultsLabel}>{count} results</span>
        <div className={styles.actionsBlock}>
          {isAdmin &&
              <Button
                  aria-label="Export"
                  variant="contained"
                  color="inherit"
                  className={styles.actionButton}
                  disabled={exportMutation.isPending}
                  startIcon={<FileDownload/>}
                  onClick={() => {
                    const {categories_values, ...rest} = filters;
                    const categoryFilters = getCategoryFilters(map, categories_values, data);
                    exportMutation.mutate({...rest, ...categoryFilters}, {
                      onSuccess: () => notifySuccess("Export completed"),
                      onError: () => notifyError("Export failed"),
                    });
                  }}
              >
                  Export
              </Button>}
          {isAdmin && <Button
              component={Link}
              to={`/${ROUTER_PATHS.profile}/${ROUTER_PATHS.newProfile}`}
              className={styles.actionButton}
              aria-label="Create profile"
              variant="contained"
              startIcon={<AddIcon/>}
          >
              Create
          </Button>}
        </div>
      </div>
      <FiltersChipPanel setScrollHeight={setScrollHeight}/>
      <div
        style={{
          height: scrollHeightValue,
          position: "relative",
        }}
      >
        {(isLoading || !data.length) ? (
          <ProfileTableSkeleton />
        ) : (
          <div
            style={{
              height: "100%",
            }}
          >
            <ProfileTable/>
          </div>
        )}
      </div>
    </div>
  );
};
